<template>
  <div id="mapa">
     <v-alert
        class="ma-0"
      border="left"
      colored-border
      type="info"
      elevation="2"
    >
    
      <h3 class="font-weight-light">Pulsar sector  <span class="caption font-weight-black">(S-1,S-2,S-3,S-4,S-5,S-6)</span> para comprar</h3>
    </v-alert>
    <div class="wrap">
       
      <img
        class="responsive"
        :src="image"
        alt="cover"
      >

      <div
        class="zone"
        v-for="(zone, index) in zones"
        :key="index"
        :style="{
          width: getZoneStyle(zone.widthPer),
          height: getZoneStyle(zone.heightPer),
          top: getZoneStyle(zone.topPer),
          left: getZoneStyle(zone.leftPer)
        }"
        @click="handleZoneClick(zone.id)"
      ></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'mapa',
  data: function () {
    return {
      image:
        'https://tickets.janto.es/hermandadesdecordoba/public/static/web/img/MAGNA2.jpg',
      zones: [
        {
          heightPer: 0.0444,
          leftPer: 0.4815,
          topPer: 0.8879,
          widthPer: 0.0582,
          id:'SECTOR_1'
        },
        {
          topPer: 0.7453,
          leftPer: 0.4429,
          widthPer: 0.0602,
          heightPer: 0.0504,
          id: 'SECTOR_2'
        },
        {
          topPer: 0.6979,
          leftPer: 0.3245,
          widthPer: 0.0602,
          heightPer: 0.0421,
          id: 'SECTOR_3'
        },
        {
          topPer: 0.579,
          leftPer: 0.3235,
          widthPer: 0.0592,
          heightPer: 0.0429,
          id: 'SECTOR_4'
        },
        {
          topPer: 0.2412,
          leftPer: 0.3255,
          widthPer: 0.0592,
          heightPer: 0.0429,
          id: 'SECTOR_5'
        },
        {
          topPer: 0.0229,
          leftPer: 0.4265,
          widthPer: 0.0551,
          heightPer: 0.0414,
          id: 'SECTOR_6'
        }
      ]
    }
  },
  computed: {
    zonas(){
      return this.$store.state.zonas
    }
  },
  methods: {
    handleAdd (zone) {
      zone.id = this.zones.length
        ? ''
        : 'https://tickets.janto.es/hermandadesdecordoba/public/janto/main.php?Nivel=Detalle_1_Sesion&idSesion=0000000000023677&idZona=SECTOR_1&idBloque=SECTOR_1_DA'

      this.zones.push(zone)
    },
    handleRemove (index) {
      this.zones.splice(index, 1)
    },
    handleChange () {
      // eslint-disable-next-line
      // console.log("Zones data updated", this.zones)
    },
    getZoneStyle (val) {
      return `${(val || 0) * 100}%`
    },
    handleZoneClick (id) {
      const zonaActual = this.zonas.find(f=>f.idZona==id)
      this.$store.commit('lateral', true)
      
      this.$store.commit('zonaActual', zonaActual)
    }
  }
}
</script>

<style>
#mapa {
  width: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
}

.wrap {
  position: relative;
}

.wrap img {
  width: 100%;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
}

.wrap .zone {
  position: absolute;
  cursor: pointer;
}

input {
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 10px;

  background: #fff;
  border: 1px solid #ccc;
  outline: none;

  color: #555;

  transition: all 0.3s ease-in-out;
}

input:focus {
  box-shadow: 0 0 5px #43d1af;
  border: 1px solid #43d1af;
}
</style>
